import { LoanFeeService } from '@/modules/global-settings/loan-origination/services/loan-policies/loan-fees.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Instantiate the service
const loanFeeService = new LoanFeeService();

// Define the state
export const state = {
  loanFees: []
};
// Define the mutations
export const mutations = {
  ...make.mutations(state)
};
// Define the actions
export const actions = {
  /**
   * Fetch all loan fees
   * @async
   * @param {object} context - The store context
   * @returns {Array} - The loan fees
   * @private This will update the state with the fetched loan fees
   */
  getLoanFees: async ({ commit }) => {
    try {
      const { data } = await loanFeeService.getLoanFees();
      commit('SET_LOAN_FEES', data);
      return data;
    } catch (error) {
      Logger.error('getting loan fee settings', error);
      throw error;
    }
  },
  /**
   * Fetch a single loan fee by id
   * @async
   * @param {object} context - The store context
   * @param {string} id - The loan fee id
   * @returns {object} - The loan fee
   */
  getLoanFee: async (_, id) => {
    try {
      const { data } = await loanFeeService.getLoanFee(id);
      return data;
    } catch (error) {
      Logger.error('getting loan fee settings', error);
      throw error;
    }
  },
  /**
   * Create a loan fee
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The payload object
   * @returns {object} - The created loan fee
   * @private This will refetch the loan fees
   */
  createLoanFee: async ({ dispatch }, payload) => {
    try {
      const { data } = await loanFeeService.createLoanFee(payload);
      dispatch('getLoanFees');
      return data;
    } catch (error) {
      Logger.error('creating loan fee settings', error);
      throw error;
    }
  },
  /**
   * Update a loan fee
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The payload object
   * @param {string} payload.id - The loan fee id
   * @param {object} payload.updates - The updates to be made
   * @returns {void}
   * @private This will refetch the loan fees
   */
  updateLoanFee: async ({ dispatch }, { id, payload }) => {
    try {
      await loanFeeService.updateLoanFee(id, payload);
      dispatch('getLoanFees');
    } catch (error) {
      Logger.error('updating loan fee settings', error);
      throw error;
    }
  },
  /**
   * Delete a loan fee
   * @async
   * @param {object} context - The store context
   * @param {string} id - The loan fee id
   * @returns {void}
   * @private This will refetch the loan fees
   */
  deleteLoanFee: async ({ dispatch }, id) => {
    try {
      await loanFeeService.deleteLoanFee(id);
      dispatch('getLoanFees');
    } catch (error) {
      Logger.error('getting loan fee settings', error);
      throw error;
    }
  }
};
// Define the getters
export const getters = make.getters(state);
